export const VIEWPORT_MD = '(min-width:600px)'
